import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import api from "../features/api/api";
import uiSlice from "../features/app/uiSlice";
import authApi from "../features/auth/authApi";
import authSlice from "../features/auth/authSlice";
import chatSlice from "../features/chat/chatSlice";
import sessionSlice from "../features/sessions/sessionSlice";

const reducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [api.reducerPath]: api.reducer,
  [authSlice.name]: authSlice.reducer,
  [sessionSlice.name]: sessionSlice.reducer,
  [chatSlice.name]: chatSlice.reducer,
  [uiSlice.name]: uiSlice.reducer,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these paths in the state
        ignoredPaths: ["uiVonage.activeDay"],
      },
    }).concat([authApi.middleware, api.middleware]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
